var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"context-menu",style:(_vm.menuStyles),on:{"click":_vm.hideMenu}},[_c('ul',_vm._l((_vm.menuItems),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.selectItem(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }